<ngx-spinner></ngx-spinner>
<section id="front_wrap">
<div class="auth-language-selector"><app-language-selector></app-language-selector></div>
<section id="connect_page">
  <div id="connect_title">
    <p>{{'auth.connectTo' | translate}}</p>
    <img src="assets/img/logo_alaya_blc.png">
  </div>
  <div id="connect_content">
    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <input type="email" formControlName="email" [placeholder]="'auth.identifier' | translate" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
      <input type="password" [placeholder]="'auth.password' | translate" formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
      <div *ngIf="submitted && f.password.errors" class="alert alert-danger" role="alert">
        <div *ngIf="f.password.errors.required">{{'auth.credentialsRequired' | translate}}</div>
      </div>
      <div *ngIf="error_logo" class="alert alert-danger" role="alert">
        <div>{{'auth.invalidCredentials' | translate}}</div>
      </div>
      <button class="blue_btn" type="submit" color="accent">{{'auth.login' | translate}}</button>
      <p style="margin-top: 25px"><a href="/password/forget">{{'auth.forgotPassword' | translate}}</a></p>
    </form>
  </div>
  <div id="connect_legal">
    <p>Certikap - par <strong>Kaptitude</strong> - 2021</p>

  </div>
</section>
</section>
